module.exports = __webpack_public_path__ + "img/11.4414d722.jpg";